import React from 'react';

import useLocal from 'localization';

import ModelListSkeleton from 'components/ModelListSkeleton';
import ModelList from 'components/ModelList';

import Props from './types';
import NotSubscribed from 'components/NotSubscribed';

const MyModelList: React.FC<Props> = ({ isLoading, showList, myModel }: Props) => {
  const subscribed = useLocal('subscribed');

  const myModelData = {
    industry: {
      id: 'my_model',
      name: subscribed
    },
    numberOfModelsInIndustry: myModel?.length ?? 0,
    clientModels: myModel
  };

  return (
    <>
      {isLoading && !myModel ? (
        <ModelListSkeleton numberOfIndustry={1} numberOfModel={30} showList={showList} />
      ) : myModelData?.clientModels?.length ? (
        <ModelList
          key={`${myModelData?.industry?.id}-${myModel?.length}`}
          {...myModelData}
          showList={showList}
          numberOfIndustriesByDefault={myModel?.length ?? 0}
          isIndustryModelLoading={null}
          maxSubscriptions={0}
          subscribedCount={0}
        />
      ) : (
        <NotSubscribed />
      )}
    </>
  );
};

export default React.memo(MyModelList);
